import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import CookieConsent from "@/components/CookieConsent";
import ScrollToTop from "@/components/ScrollToTop";

// Pages
import Home from "@/pages/Home";
import Games from "@/pages/Games";
import Ranking from "@/pages/Ranking";
import MissieVisie from "@/pages/MissieVisie";
import Geschiedenis from "@/pages/Geschiedenis";
import Organigram from "@/pages/Organigram";
import Vacatures from "@/pages/Vacatures";
import Contact from "@/pages/Contact";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Teams from "@/pages/Teams";
import Sponsors from "@/pages/Sponsors";
import Shop from "@/pages/Shop";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Inschrijvingen from "@/pages/Inschrijvingen";
import LogoDownload from "@/pages/LogoDownload";

// Sport Eldorado Pages
import SportEldorado from "@/pages/SportEldorado";
import SportEldoradoMissie from "@/pages/SportEldoradoMissie";
import SportEldoradoTeam from "@/pages/SportEldoradoTeam";
import SportEldoradoGalerij from "@/pages/SportEldoradoGalerij";
import SportEldoradoKalender from "@/pages/SportEldoradoKalender";

// Error Pages
import NotFound from "@/pages/NotFound";
import ServerError from "@/pages/ServerError";
import Forbidden from "@/pages/Forbidden";
import Offline from "@/pages/Offline";

// Admin Pages
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminMatches from "@/pages/admin/AdminMatches";
import AdminNews from "@/pages/admin/AdminNews";
import AdminPlayers from "@/pages/admin/AdminPlayers";
import AdminStandings from "@/pages/admin/AdminStandings";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminSponsors from "@/pages/admin/AdminSponsors";
import AdminTeams from "@/pages/admin/AdminTeams";
import AdminLocations from "@/pages/admin/AdminLocations";
import AdminCompetitions from "@/pages/admin/AdminCompetitions";
import AdminShop from "@/pages/admin/AdminShop";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminVacancies from "@/pages/admin/AdminVacancies";
import AdminApplications from "@/pages/admin/AdminApplications";
import AdminGallery from "@/pages/admin/AdminGallery";
import AdminActivities from "@/pages/admin/AdminActivities";
import AdminEldoradoTeam from "@/pages/admin/AdminEldoradoTeam";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";
import AdminRegistrations from "@/pages/admin/AdminRegistrations";
import AdminPlayerRegistrations from "@/pages/admin/AdminPlayerRegistrations";
import AdminStaff from "@/pages/admin/AdminStaff";

// Layout
import Layout from "@/components/Layout";
import AdminLayout from "@/components/AdminLayout";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public Routes */}
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/games" element={<Games />} />
            <Route path="/ranking" element={<Ranking />} />
            <Route path="/club/missie-visie" element={<MissieVisie />} />
            <Route path="/club/geschiedenis" element={<Geschiedenis />} />
            <Route path="/club/organigram" element={<Organigram />} />
            <Route path="/vacatures" element={<Vacatures />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:id" element={<NewsDetail />} />
            <Route path="/teams" element={<Teams />} />
            <Route path="/teams/:category" element={<Teams />} />
            <Route path="/sponsors" element={<Sponsors />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/inschrijvingen" element={<Inschrijvingen />} />
            <Route path="/club/logo" element={<LogoDownload />} />
            <Route path="/nieuws" element={<News />} />
            <Route path="/nieuws/:id" element={<NewsDetail />} />
            
            {/* Sport Eldorado Routes */}
            <Route path="/sport-eldorado" element={<SportEldorado />} />
            <Route path="/sport-eldorado/missie-visie" element={<SportEldoradoMissie />} />
            <Route path="/sport-eldorado/team" element={<SportEldoradoTeam />} />
            <Route path="/sport-eldorado/galerij" element={<SportEldoradoGalerij />} />
            <Route path="/sport-eldorado/kalender" element={<SportEldoradoKalender />} />

            {/* Error Pages */}
            <Route path="/500" element={<ServerError />} />
            <Route path="/403" element={<Forbidden />} />
            <Route path="/offline" element={<Offline />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/matches" element={<AdminMatches />} />
            <Route path="/admin/matches/:category" element={<AdminMatches />} />
            <Route path="/admin/news" element={<AdminNews />} />
            <Route path="/admin/players" element={<AdminPlayers />} />
            <Route path="/admin/staff" element={<AdminStaff />} />
            <Route path="/admin/standings" element={<AdminStandings />} />
            <Route path="/admin/standings/:category" element={<AdminStandings />} />
            <Route path="/admin/contacts" element={<AdminContacts />} />
            <Route path="/admin/categories" element={<AdminCategories />} />
            <Route path="/admin/sponsors" element={<AdminSponsors />} />
            <Route path="/admin/teams" element={<AdminTeams />} />
            <Route path="/admin/locations" element={<AdminLocations />} />
            <Route path="/admin/competitions" element={<AdminCompetitions />} />
            <Route path="/admin/shop" element={<AdminShop />} />
            <Route path="/admin/orders" element={<AdminOrders />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/vacancies" element={<AdminVacancies />} />
            <Route path="/admin/applications" element={<AdminApplications />} />
            <Route path="/admin/gallery" element={<AdminGallery />} />
            <Route path="/admin/activities" element={<AdminActivities />} />
            <Route path="/admin/eldorado-team" element={<AdminEldoradoTeam />} />
            <Route path="/admin/newsletter" element={<AdminNewsletter />} />
            <Route path="/admin/registrations" element={<AdminRegistrations />} />
            <Route path="/admin/player-registrations" element={<AdminPlayerRegistrations />} />
          </Route>
        </Routes>
        <CookieConsent />
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </div>
  );
}

export default App;
